import BlockIntegrationListing from './integrationListing'

export default BlockIntegrationListing
